module.exports = __webpack_public_path__ + "static/media/Eggplant.6bf69ec6.jpg";